import { TtoCampaignVideoDto } from '@/app/common/general-types/tiktok-one-reporting.dto';
import { SparkAd } from '@/app/common/general-types/tiktok-spark-ads.dto';
import { TiktokOneReportingService } from '@/app/services/tiktok-one-reporting/tiktok-one-reporting.service';
import { TiktokSparkAdsService } from '@/app/services/tiktok-spark-ads/tiktok-spark-ads.service';
import { TikTokBusinessService } from '@/app/services/tiktok-business/tiktok-business.service';
import { ManageBriefTabsService } from '@/app/pages/manage-brief-tabs/service/manage-brief-tabs/manage-brief-tabs.service';
import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { take } from 'rxjs';

@Component({
  selector: 'vat-analysis-boosting',
  imports: [],
  templateUrl: './analysis-boosting.html',
  styleUrl: './analysis-boosting.css',
})
export class AnalysisBoostingComponent implements OnInit {

  readonly video = input.required<TtoCampaignVideoDto>();

  sparkAdAuthStatus = signal<{
    code: number;
    message: string;
    request_id: string;
    data: {
      auth_code: string;
      auth_code_end_time: string;
      auth_code_start_time: string;
      auth_code_status: string;
      video_id: string;
    };
  } | undefined>(undefined);

  isCreating = signal<boolean>(false);
  createError = signal<string | null>(null);
  createSuccess = signal<boolean>(false);
  existingSparkAds = signal<SparkAd[]>([]);
  sparkAdsLoading = signal<boolean>(false);
  selectedObjectiveType = signal<string>('VIDEO_VIEWS');
  advertiserAccounts = signal<string[]>([]);
  selectedAdvertiserId = signal<string>('');

  readonly objectiveOptions: { value: string; label: string }[] = [
    { value: 'APP_PROMOTION',   label: 'App Promotion' },
    { value: 'ENGAGEMENT',      label: 'Engagement' },
    { value: 'LEAD_GENERATION', label: 'Lead Generation' },
    { value: 'REACH',           label: 'Reach' },
    { value: 'TRAFFIC',         label: 'Traffic' },
    { value: 'VIDEO_VIEWS',     label: 'Video Views' },
    { value: 'WEB_CONVERSIONS', label: 'Web Conversions' },
  ];

  canCreateSparkAd = computed(() =>
    !!this.sparkAdAuthStatus()?.data?.auth_code &&
    this.existingSparkAds().length === 0 &&
    !this.isCreating() &&
    !!this.selectedAdvertiserId()
  );

  /** Services */
  private tiktokOneReportingService = inject(TiktokOneReportingService);
  manageBriefTabsService = inject(ManageBriefTabsService);
  private tiktokSparkAdsService = inject(TiktokSparkAdsService);
  private tiktokBusinessService = inject(TikTokBusinessService);
  /** Services - END */

  ngOnInit(): void {
    this.getSparkAuthStatus();
    this.loadExistingSparkAds();
    this.loadAdvertiserAccounts();
    const goalName = this.manageBriefTabsService.focussedBrief()?.brief_goal_name ?? '';
    if (goalName) this.selectedObjectiveType.set(this.mapBriefGoalToObjective(goalName));
  }

  getSparkAuthStatus() {
    console.log('getSparkAuthStatus() -->');
    console.log('video:', this.video());
    this.tiktokOneReportingService.getSparkAuthStatus(this.video().video_info.video_id).subscribe((sparkAuthStatusRes: {
      code: number;
      message: string;
      request_id: string;
      data: {
        auth_code: string;
        auth_code_end_time: string;
        auth_code_start_time: string;
        auth_code_status: "NOT_USED" | "IN_USE" | "EXPIRED" | string;
        auth_status?: "ACCEPTED" | "REJECTED" | string | undefined;
        video_id: string;
      }
    }) => {
      console.log('Spark Auth Status Res:', sparkAuthStatusRes);
      this.sparkAdAuthStatus.set(sparkAuthStatusRes);
    });
  }

  applyForAuth() {
    console.log('applySparkAuthorizationCode() -->');
    this.tiktokOneReportingService.requestSparkAuth(this.video().video_info.video_id).subscribe((sparkAuthStatusRes: any) => {
      console.log('Spark Auth Status Res:', sparkAuthStatusRes);
      this.sparkAdAuthStatus.set(sparkAuthStatusRes);
    });
  }

  applySparkAuthorizationCode() {
    console.log('applySparkAuthorizationCode() -->');
    console.log('sparkAdAuthStatus:', this.sparkAdAuthStatus());
    if (!this.sparkAdAuthStatus()) return;
    this.tiktokOneReportingService.applySparkAuthorizationCode(this.video().video_info.video_id, this.sparkAdAuthStatus()!.data.auth_code).subscribe((sparkAuthStatusRes: any) => {
      console.log('Spark Auth Status Res:', sparkAuthStatusRes);
      this.sparkAdAuthStatus.set(sparkAuthStatusRes);
    });
  }

  loadAdvertiserAccounts(): void {
    const brief = this.manageBriefTabsService.focussedBrief();
    if (!brief?.businessAccountId) return;
    this.tiktokBusinessService.getAdvertiserAccounts(brief.businessAccountId)
      .pipe(take(1))
      .subscribe({
        next: (accounts) => {
          this.advertiserAccounts.set(accounts);
          if (accounts.length === 1) this.selectedAdvertiserId.set(accounts[0]);
        },
        error: () => {},
      });
  }

  loadExistingSparkAds(): void {
    const brief = this.manageBriefTabsService.focussedBrief();
    if (!brief?.id || !brief?.businessAccountId) return;
    this.sparkAdsLoading.set(true);
    this.tiktokSparkAdsService.getSparkAds(brief.id, brief.businessAccountId)
      .pipe(take(1))
      .subscribe({
        next: (ads) => { this.existingSparkAds.set(ads); this.sparkAdsLoading.set(false); },
        error: () => this.sparkAdsLoading.set(false),
      });
  }

  createCampaignAndSparkAd(): void {
    // const authStatus = this.sparkAdAuthStatus();
    // const brief = this.manageBriefTabsService.focussedBrief();
    // if (!authStatus?.data?.auth_code || !brief?.id || !brief?.businessAccountId) return;

    // this.isCreating.set(true);
    // this.createError.set(null);
    // this.createSuccess.set(false);

    // this.tiktokSparkAdsService.createSparkAd({
    //   briefId: brief.id,
    //   businessAccountId: brief.businessAccountId,
    //   submittedPostId: this.video().video_info.video_id,
    //   adCode: authStatus.data.auth_code,
    //   adName: brief.title,
    //   campaignName: brief.title,
    //   objectiveType: this.selectedObjectiveType(),
    //   advertiserAccountId: this.selectedAdvertiserId() || undefined,
    // }).pipe(take(1)).subscribe({
    //   next: () => {
    //     this.createSuccess.set(true);
    //     this.isCreating.set(false);
    //     this.loadExistingSparkAds();
    //   },
    //   error: (err: { error?: { message?: string } }) => {
    //     this.createError.set(err?.error?.message ?? 'Failed to create Spark Ad campaign');
    //     this.isCreating.set(false);
    //   },
    // });
  }

  private mapBriefGoalToObjective(goalName: string): string {
    const n = goalName.toLowerCase();
    if (n.includes('awareness') || n.includes('reach')) return 'REACH';
    if (n.includes('view') || n.includes('video')) return 'VIDEO_VIEWS';
    if (n.includes('engagement') || n.includes('consideration')) return 'ENGAGEMENT';
    if (n.includes('traffic')) return 'TRAFFIC';
    if (n.includes('conversion') || n.includes('purchase')) return 'WEB_CONVERSIONS';
    if (n.includes('lead')) return 'LEAD_GENERATION';
    if (n.includes('app')) return 'APP_PROMOTION';
    return 'VIDEO_VIEWS';
  }
}
